import { Box } from '@chakra-ui/react'
import { apps } from 'config/apps'
import { BotulismPages } from 'config/apps/Botulism/BotulismPages'
import { createElement } from 'react'

const GuidelineTable = () => {
  const page = BotulismPages['BotulismGuidelineTable']
  return (
    <Box>
      {createElement(page.component, {
        app: apps['botulism'],
        views: page.views,
        model: {
          ...page.model,
          tableHeight: '85vh',
          onlyAllowExport: true,
        },
        page: page,
      })}
    </Box>
  )
}

export default GuidelineTable
